import * as Yup from "yup";

import { Common, VALIDATION } from "../helper";

const PasswordUpdateValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().required(VALIDATION.OLD_PASSWORD_IS_REQUIRED),
  newPassword: Yup.string().required(VALIDATION.PASSWORD_MUST_HAVE_AT_LEAST_ONE_UPPERCASE_LOWERCASE_NUMBER_SPECAIL_CHARACTER).matches(
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).+$/,
    "Password must contain at least 1 lowercase, 1 uppercase, 1 number, and 1 special character"
  ).min(8, VALIDATION.PASSWORD_MUST_HAVE_MINIMUM_8_CHARACTERS),
  confirmPassword: Yup.string().oneOf([Yup.ref("newPassword"), null], VALIDATION.PASSWORD_MUST_MATCH).required()
});

const profileUpdateValidationSchema = Yup.object().shape({
  FirstName: Yup.string().required(VALIDATION.FIRST_NAME_IS_REQUIRED).min(2, VALIDATION.NAME_SHOULD_CONTAIN_ATLEAST_3_CHARACTERS).max(25, Common.LengthRestriction),
  LastName: Yup.string().required(VALIDATION.LAST_NAME_IS_REQUIRED).min(2, VALIDATION.NAME_SHOULD_CONTAIN_ATLEAST_3_CHARACTERS).max(25, Common.LengthRestriction)

})

export { PasswordUpdateValidationSchema, profileUpdateValidationSchema };